// fonts.js
const fonts = {
  // Primary font - Prata (for headings, logo, emphasis)
  primary: '"Prata", serif',

  // Secondary font - Questrial (for body text, navigation)
  secondary: '"Questrial", sans-serif',
};

export default fonts;
